import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MTopBar, SaleBar } from "@/components/mobile/MTopBar";
import { MPage, Footer, EmptyArt, cardCls } from "@/components/mobile/parts";
import { CartRow } from "@/pages/mobile/MCart";
import { useCartActions } from "@/pages/mobile/MProducts";
import { DIRECT_CART } from "@/pages/mobile/MDirectSale";
import { brl } from "@/lib/api";
import { cn } from "@/lib/utils";

export default function MDirectCart() {
  const { cart, setCart, total, count } = useCartActions(DIRECT_CART);
  const nav = useNavigate();
  const upd = (key, patch) => setCart((cs) => cs.map((i) => (i.key === key ? { ...i, ...patch } : i)));
  const setQty = (key, qty) => (qty <= 0 ? setCart((cs) => cs.filter((i) => i.key !== key)) : upd(key, { qty }));

  return (
    <>
      <MTopBar title={`Carrinho (${count})`} back="/m/venda-direta" />
      <SaleBar />
      <MPage>
        {!cart.length ? <EmptyArt icon={ShoppingCart} title="Carrinho vazio" text="Volte para os produtos e toque nos itens para montar a venda." testId="m-cart-empty" /> : (
          <ul className={cn(cardCls, "divide-y divide-slate-100")} data-testid="m-cart-list">
            {cart.map((i) => <CartRow key={i.key} i={i} upd={upd} setQty={setQty} />)}
          </ul>
        )}
        <Link to="/m/venda-direta" className="block text-center text-sm font-semibold text-[#1565c0]" data-testid="m-cart-add-more">+ Adicionar mais itens</Link>
      </MPage>
      <Footer className="border-t bg-white px-4 py-3 shadow-[0_-8px_24px_rgba(15,23,42,0.08)]" testId="m-direct-pay-footer">
        <Button onClick={() => nav("/m/venda-direta/pagamento")} disabled={!cart.length} className="h-14 w-full justify-between rounded-xl bg-[#16a34a] px-5 text-base text-white hover:bg-[#15803d]" data-testid="m-direct-pay-btn">
          <span className="flex items-center gap-2"><Wallet className="h-5 w-5" />Receber</span>
          <span className="font-mono text-lg font-bold" data-testid="m-direct-pay-total">{brl(total)}</span>
        </Button>
      </Footer>
    </>
  );
}
